function updateSortUrl(newValue, ) {
  const urlParams = new URLSearchParams(window.location.search);
  let newUrl = window.location.origin + window.location.pathname;
  if (urlParams.has('sort_by')) {
    urlParams.set('sort_by', newValue);
  } else {
    urlParams.append('sort_by', newValue);
  }
  newUrl += '?' + urlParams.toString();
  return newUrl;
}

function setValue(){
    const range = $('#price-range'),
          newValue = Number( (range.val() - range.attr('min')) * 100 / (range.attr('max') - range.attr('min')) ), 
          newPosition = 16 - (newValue * 0.32), 
          tooltipnewPosition = 10 - (newValue * 0.32);
    $('#price-tooltip').html('<span>'+Shopify.formatMoney(range.val() * 100, Shopify.money_format).replace('.00','')+'</span>').css('left',`calc(${newValue}% + (${tooltipnewPosition}px))`);
    document.documentElement.style.setProperty("--range-progress", `calc(${newValue}% + (${newPosition}px))`);
};

// data change
function getData(newURL, section_id){
  const del = newURL.indexOf('?') > -1 ? '&' : '?', getURL = newURL + del +'section_id=' + section_id;
  $.get(getURL, function( data ) {          
    history.pushState('', '', newURL);
    $('body').find('[data-collection-grid]').html($(data).find('[data-collection-grid]').html());
    // $('body').find('#FacetFiltersForm').html($(data).find('#FacetFiltersForm').html());
    // $('body').find('[data-collection-sort]').html($(data).find('[data-collection-sort]').html());
    $('body').find('[data-product-count]').html($(data).find('[data-product-count]').html());

    // NEW FILTER 2/12/24
    $('body').find('[data-collection-newFilter]').html($(data).find('[data-collection-newFilter]').html());
    
    setValue();

    var totalCol = $('.main_collection_sec').offset().top;
    setTimeout(function(){
      $("html, body").animate({ scrollTop: totalCol }, "300");
    }, 1000);
  });
}

$(document).ready(function(e){ 
  setValue();
});     
// filters
$('body').on('change', '[data-facetFilter], #price-range', function(e){
  e.preventDefault();  
  var facetForm = $(this).closest('form#FacetFiltersForm'), 
      searchParams = facetForm.serialize(), 
      section_id = $(this).data('section-id'), 
      totalProducts = facetForm.find('input[name^=filter]:checked'),
      priceMaxFilter = facetForm.find('#price-range').attr('max'),
      priceFilterValue = facetForm.find('#price-range').val(),
      newUrl = window.location.origin + window.location.pathname;
  
  if ((totalProducts.length != 0 || priceMaxFilter != priceFilterValue)
    ? $('.filter-buttons').show().find('[data-clearAll] span').html('('+totalProducts.length+')')
    : $('.filter-buttons').hide().find('[data-clearAll] span').empty()
  )

  window.filterURL = newUrl + '?' + searchParams;
  if ($(window).width() > 767) getData(window.filterURL, section_id);
});

$('body').on('input', '#price-range', function(e){
  setValue();
});

$('body').on('click','[data-clearAll]', function(e){
  e.preventDefault();
  getData($(this).data('href'), $(this).data('section-id'));
  $('.filter-buttons').hide().find('[data-clearAll] span').empty();
});

$('body').on('click','[data-applyAll]', function(e){
  e.preventDefault();
  if (window.filterURL != undefined) getData(window.filterURL, $(this).data('section-id'));
  $('.fs_close_icons').trigger('click');
});

$('body').on('click','.sort_dropDown button', function(){ 
  $(this).parents('.sort_dropDown').toggleClass('active');
});

// $('body').on('click','.sort_dropDown .dropdown_opt li', function(){ 
//    $(this).addClass('active').siblings('li').removeClass('active');
//    $(this).parents('.sort_dropDown').find('button p').text($(this).find('p').text())
//    $(this).parents('.sort_dropDown').removeClass('active');
//    getData(updateSortUrl($(this).data('value')), $(this).data('section-id'));
// });
// sort

// NEW FACETS 2/12/24 Start
$('body').on('change','.new--filter_dropDown .dropdown_opt li input', function(e){ 
  e.preventDefault();
  
    if ($(this).is(":checked")) {
      $(this).parents('.new--filter_dropDown').find('input').prop("checked", false);
      $(this).prop("checked", true);
    } else {
      $(this).prop("checked", false);
    }
    
     var facetForm = $(this).closest('form#new-FacetFiltersForm'), 
        searchParams = facetForm.serialize(), 
        section_id = $(this).data('section-id'),
        newUrl = window.location.origin + window.location.pathname;
  
  window.filterURL = newUrl + (searchParams ? '?' + searchParams : '');
  getData(window.filterURL, section_id);
});
// NEW FACETS 2/12/24 End